export enum TipoColunaEnum {
  Data = 'Data',
  DataMesAno = 'DataMesAno',
  DataEHora = 'DataEHora',
  Porcentagem = 'Porcentagem',
  PorcentagemComDecimal = 'PorcentagemComDecimal',
  Valor = 'Valor',
  Statuses = 'Statuses',
  Arquivo = 'Arquivo',
  Acoes = 'Acoes',
  Cpf = 'Cpf',
  Cnpj = 'Cnpj',
  Tag = 'Tag',
  Telefone = 'Telefone',
  Logo = 'Logo',
  Setor = 'Setor',
  Socio = 'Socio',
  Email = 'Email'
}
